import { departmentDashboard } from '../../actions/constant';

const { GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE, GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS } =
  departmentDashboard;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
};

export const getDepartmentDashboardCountReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
      };
    }

    case GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };

    default:
      return state;
  }
};
